import React, { Component } from 'react'
const EventPaths = {
	"marche": "regionali-2025-09",
	"valle-d-aosta": "regionali-2025-09",
	"calabria": "regionali-2025-10",
	"toscana": "regionali-2025-10",
	"veneto": "regionali-2025-11",
	"campania": "regionali-2025-11",
	"puglia": "regionali-2025-11",
}

export default EventPaths
